import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { translate } from '../../../../utils/util';
import { checkPermission } from '../../../../services/auth';
import { PERMISSIONS } from '../../../../utils/constants';
import { ListLinkBox, BackButton, Title, Subtitle } from '../../../../components/UI/ComponentsUI';

const Parameterization = (props) => {
    const menu = () => {
        let menuItems = [];
        if (checkPermission(PERMISSIONS.Config.PhysicalConfirmation.Access)) {
            menuItems = [...menuItems, { route: 'params/physicalConfirmation', icon: 'mdi mdi-clipboard-check', text: translate('menu:physical-confirmation') }];
        }

        if (checkPermission(PERMISSIONS.Config.Inventory.Access)) {
            menuItems = [...menuItems, { route: 'params/inventory', icon: 'mdi mdi-clipboard-check-outline', text: translate('menu:inventory') }];
        }

        if (checkPermission(PERMISSIONS.Config.Expedition.Picking)) {
            menuItems = [...menuItems, { route: 'params/picking', icon: 'mdi mdi-dolly', text: translate('menu:picking') }];
        }

        if (checkPermission(PERMISSIONS.Config.Expedition.Picking)) {
            menuItems = [...menuItems, { route: 'params/linepicking', icon: 'mdi mdi-timetable', text: translate('menu:line-picking') }];
        }


        if (checkPermission(PERMISSIONS.Config.ChangeLocation.Access)) {
            menuItems = [...menuItems, { route: 'params/changeLocation', icon: 'mdi mdi-find-replace', text: translate('menu:exchange-location') }];
        }

        if (checkPermission(PERMISSIONS.Config.Access)) {
            menuItems = [...menuItems, { route: 'params/volume', icon: 'mdi mdi-layers-triple-outline', text: translate('menu:volume') }];
        }


        if (checkPermission(PERMISSIONS.Config.ChangeLocation.Access)) {
            menuItems = [...menuItems, { route: 'params/warehouseManagement', icon: 'edit_location', text: translate('menu:warehouse-management') }];
        }

        return menuItems;
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-cogs" label={translate('menu.parameterization', 'configuration')} />
                    <Subtitle label={translate('menu.module', 'configuration')} />
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

export default withRouter(withTranslation()(Parameterization));
